import { render, staticRenderFns } from "./manageCardholders.vue?vue&type=template&id=6f4b7b45&scoped=true"
import script from "./manageCardholders.vue?vue&type=script&lang=js"
export * from "./manageCardholders.vue?vue&type=script&lang=js"
import style0 from "./manageCardholders.vue?vue&type=style&index=0&id=6f4b7b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b7b45",
  null
  
)

export default component.exports